import { I18n } from '@calendly/i18n'
import { Avatar } from '@calendly/ui/components/avatar'
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy'
import { BodyText } from '@calendly/ui/components/typography'

import { RECAP_PERMISSION_RELATIONS } from 'features/recaps/constants'
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context'

import {
  PermissionSelectReadOnly,
  RecipientPermissionSelect,
} from './permission_select'
import {
  AccessListItem,
  AccessListItemContent,
  AccessListItemLeading,
  AccessListItemText,
  accessListItemTextLineCss,
} from './styles'

const getDisplayName = (user, variant) => {
  if (variant === 'currentSharer') {
    return I18n.t('publisher.meeting_recap.share_modal.access_list.current_user_name', {
      name: user.name,
    })
  }

  if (variant === 'owner' && user.isCurrentUser) {
    return I18n.t('publisher.meeting_recap.share_modal.access_list.owner_name', {
      name: user.name,
    })
  }

  return user.name
}

export const UserAccessListItem = ({
  user,
  testId,
  variant = 'grant',
}) => {
  const {
    permissionUpdates: {
      getUserRelation,
      setPendingUserPermission,
    },
  } = useRecapShare()

  const displayName = getDisplayName(user, variant)
  const relation = getUserRelation(user.uuid, user.relation)

  const renderAction = () => {
    if (variant === 'owner') {
      return (
        <PermissionSelectReadOnly
          label={I18n.t('publisher.meeting_recap.share_modal.access_list.permission_select.owner')}
          testId={`${testId}-permission`}
        />
      )
    }

    if (variant === 'currentSharer') {
      return (
        <PermissionSelectReadOnly
          label={I18n.t('publisher.meeting_recap.share_modal.access_list.permission_select.can_view_and_share')}
          testId={`${testId}-permission`}
        />
      )
    }

    return (
      <RecipientPermissionSelect
        uuid={user.uuid}
        value={relation ?? RECAP_PERMISSION_RELATIONS.VIEWER}
        onChange={(selectedRelation) => setPendingUserPermission(user.uuid, selectedRelation)}
        onRemove={() => setPendingUserPermission(user.uuid, null)}
      />
    )
  }

  return (
    <AccessListItem data-testid={testId}>
      <AccessListItemContent>
        <AccessListItemLeading>
          <FullStoryExclude>
            <Avatar
              size="small"
              src={user.avatarUrl}
              letter={user.avatarLetter}
              aria-label={user.name}
              aria-hidden
              tabIndex={-1}
            />
          </FullStoryExclude>
        </AccessListItemLeading>
        <AccessListItemText>
          <BodyText className={accessListItemTextLineCss}>{displayName}</BodyText>
          {user.email ? (
            <BodyText className={accessListItemTextLineCss} color="muted" size="small">{user.email}</BodyText>
          ) : null}
        </AccessListItemText>
      </AccessListItemContent>
      {renderAction()}
    </AccessListItem>
  )
}
